import { useContext } from 'react';
import { Button } from '@material-ui/core';
import MyDataSpacesViewContext from '../../context/MyDataSpacesViewContext';
import { trackEvent } from '../../../../utils/eventTracking';
import { UserProfileContext } from '../../../../UserProfileContext';

// Redirects user from Data Directory page to Dataspace Configuration page.
const BackButton = () => {
	const userProfile = useContext(UserProfileContext)[0];

	const myDataSpacesViewContext = useContext(MyDataSpacesViewContext);

	const returnToDataDirectory = () => {
		myDataSpacesViewContext.changeViewHandler('editDataSpaceFormSelectData');

		trackEvent({
			userDetails: { userId: userProfile._id, email: userProfile.email },
			eventDetails: {
				types: ['KissMetrics', 'Segment', 'Encharge', 'GA4'],
				eventName: 'Returned to Data Selection Page from Joins Page in Edit Dataspace Form',
			},
		});
	};

	return (
		<Button variant="contained" margin="normal" color="primary" onClick={returnToDataDirectory}>
			Add More Data
		</Button>
	);
};

export default BackButton;
